module.exports = __webpack_public_path__ + "static/testmonial-1-ff12f0af98db1989f4c4fe04213d1985.png";